import rocket_boy from '../Assets/img-min/svg/rocket_boy.svg';
import coding from '../Assets/img-min/svg/coding.svg';
import wallet from '../Assets/img-min/svg/wallet.svg';
import Thinking from '../Assets/img/Icon/thinking.png';
import Inovative from '../Assets/img/Icon/Inovative.png';
import Adaptation from '../Assets/img/Icon/adaptation.png';
import client from '../Assets/img/Icon/business1.png';
import global from '../Assets/img/Icon/global.png';
import Quality from '../Assets/img/Icon/reliability.png';
import Budget from '../Assets/img/Icon/budget.png';
import Payment_Method from '../Assets/img/Icon/payment-method.png';
import Pricing from '../Assets/img/Icon/market-research.png';
function Performance() {
    return (
        <div id="performance" className="section py-6 py-md-7 bg-body">
            <div className="container">

                <div className="row text-center">
                    <div className="col-12">
                        <div className="mb-5">
                            <h2 className="h3 fw-bold"> What Sets Us Apart</h2>
                            <hr className="divider my-4 mx-auto bg-warning border-warning" />
                            <p className="lead text-muted">Unveiling the Distinctive Edge of Our IT Company.</p>
                        </div>
                    </div>
                </div>

                <div className="row mb-5 mb-lg-7">
                    <div className="col-lg-6 align-self-center">
                        <div className="px-5 px-md-7 mb-5 mb-lg-0" data-aos="fade-right" data-aos-delay="100">
                            <img src={rocket_boy} className="img-fluid" alt="landing page" />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <ol className="process-vertical ps-0" data-aos="flip-up">
                            <li className="process-vertical-item">
                                <div className="process-vertical-icon">
                                    <div className="process-vertical-icon-bg bg-light-dark me-auto rounded-circle p-2">
                                        <span>
                                            <img className='image-fluid' src={Thinking} alt='thinking icon image' width={'100%'} height={'100%'} />
                                        </span>
                                    </div>
                                </div>

                                <div className="process-vertical-content ms-lg-4">
                                    <h3 className="h5">Expertise Beyond Boundaries</h3>
                                    <p>At <strong>Viable Informatics Clues</strong>, we boast a team of seasoned professionals with diverse expertise spanning across various domains of IT.</p>
                                </div>
                            </li>

                            <li className="process-vertical-item">
                                <div className="process-vertical-icon">
                                    <div className="process-vertical-icon-bg bg-light-dark me-auto rounded-circle p-2">
                                        <span>
                                            <img className='image-fluid' src={Inovative} alt='Inovative icon image' width={'100%'} height={'100%'} />
                                        </span>
                                    </div>
                                </div>

                                <div className="process-vertical-content ms-lg-4">
                                    <h3 className="h5">Innovative Solutions</h3>
                                    <p>Innovation is our company's lifeblood, propelling us to constantly explore new ideas and cutting-edge tools to deliver business growth.</p>
                                </div>
                            </li>

                            <li className="process-vertical-item">
                                <div className="process-vertical-icon">
                                    <div className="process-vertical-icon-bg bg-light-dark me-auto rounded-circle p-2">
                                        <span>
                                            <img className='image-fluid' src={Adaptation} alt='Adaptation icon image' width={'100%'} height={'100%'} />
                                        </span>
                                    </div>
                                </div>

                                <div className="process-vertical-content ms-lg-4">
                                    <h3 className="h5">Agility and Adaptability</h3>
                                    <p><strong>Viable Informatics Clues</strong>, excelling in adaptability, swiftly adjusts to market shifts, tech advances, and client demands, ensuring our clients lead the pack.</p>
                                </div>
                            </li>
                        </ol>
                    </div>
                </div>

                <div className="row mb-5 mb-lg-7">
                    <div className="col-lg-6 order-lg-2  align-self-center">
                        <div className="px-5 px-md-7 mb-5 my-lg-0" data-aos="fade-left" data-aos-delay="100">
                            <img src={coding} className="img-fluid" alt="landing page" />
                        </div>
                    </div>
                    <div className="col-lg-6 order-lg-1">
                        <ol className="process-vertical ps-0" data-aos="flip-up">
                            <li className="process-vertical-item">
                                <div className="process-vertical-icon">
                                    <div className="process-vertical-icon-bg bg-light-dark me-auto rounded-circle p-2">
                                        <span>
                                            <img className='image-fluid' src={client} alt='client icon image' width={'100%'} height={'100%'} />
                                        </span>
                                    </div>
                                </div>

                                <div className="process-vertical-content ms-lg-4">
                                    <h3 className="h5">Client-Centric Approach</h3>
                                    <p>With a client-centric approach, we forge lasting partnerships, delivering tailored solutions that match their needs, fostering trust and reliability for enduring relationships.</p>
                                </div>
                            </li>

                            <li className="process-vertical-item">
                                <div className="process-vertical-icon">
                                    <div className="process-vertical-icon-bg bg-light-dark me-auto rounded-circle p-2">
                                        <span>
                                            <img className='image-fluid' src={global} alt='global icon image' width={'100%'} height={'100%'} />
                                        </span>
                                    </div>
                                </div>

                                <div className="process-vertical-content ms-lg-4">
                                    <h3 className="h5">Global Reach Local Presence</h3>
                                    <p>With a global footprint and local presence, our distributed teams collaborate seamlessly across geographies, delivering superior solutions with a localized touch.</p>
                                </div>
                            </li>

                            <li className="process-vertical-item">
                                <div className="process-vertical-icon">
                                    <div className="process-vertical-icon-bg bg-light-dark me-auto rounded-circle p-2">
                                        <span>
                                            <img className='image-fluid' src={Quality} alt='Quality icon image' width={'100%'} height={'100%'} />
                                        </span>
                                    </div>
                                </div>
                                <div className="process-vertical-content ms-lg-4">
                                    <h3 className="h5">Commitment to Quality</h3>
                                    <p> Quality is non-negotiable for us. From project inception to completion, we adhere to the highest standards of quality assurance, ensuring that every deliverable meets or exceeds our client's expectations. </p>
                                </div>
                            </li>
                        </ol>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-6 align-self-center">
                        <div className="px-5 px-md-7 mb-5 my-lg-0" data-aos="fade-right" data-aos-delay="100">
                            <img src={wallet} className="img-fluid" alt="landing page" />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <ol className="process-vertical ps-0" data-aos="flip-up">
                            <li className="process-vertical-item">
                                <div className="process-vertical-icon">
                                    <div className="process-vertical-icon-bg bg-light-dark me-auto rounded-circle p-2">
                                        <span>
                                            <img className='image-fluid' src={Budget} alt='Budget icon image' width={'100%'} height={'100%'} />
                                        </span>
                                    </div>
                                </div>

                                <div className="process-vertical-content ms-lg-4">
                                    <h3 className="h5">Cost-Effective Solutions</h3>
                                    <p> We understand the importance of cost-efficiency in today's competitive business environment. Our IT solutions are designed to maximize value while minimizing costs, ensuring that you get the most out of your investment.</p>
                                </div>
                            </li>

                            <li className="process-vertical-item">
                                <div className="process-vertical-icon">
                                    <div className="process-vertical-icon-bg bg-light-dark me-auto rounded-circle p-2">
                                        <span>
                                            <img className='image-fluid' src={Pricing} alt='Pricing  icon image' width={'100%'} height={'100%'} />
                                        </span>
                                    </div>
                                </div>

                                <div className="process-vertical-content ms-lg-4">
                                    <h3 className="h5">Transparent Pricing Models</h3>
                                    <p>Transparency is key when it comes to pricing. We offer clear and transparent pricing models, with no hidden fees or surprises. Our clients can trust that they're getting fair and competitive pricing for our services.</p>
                                </div>
                            </li>

                            <li className="process-vertical-item">
                                <div className="process-vertical-icon">
                                    <div className="process-vertical-icon-bg bg-light-dark me-auto rounded-circle p-2">
                                        <span>
                                            <img className='image-fluid' src={Payment_Method} alt='Payment Method icon image' width={'100%'} height={'100%'} />
                                        </span>
                                    </div>
                                </div>

                                <div className="process-vertical-content ms-lg-4">
                                    <h3 className="h5">Flexible Payment Options</h3>
                                    <p>We offer flexible payment options tailored to your budget and cash flow requirements. Whether it's a one-time payment, monthly installments, or a customized payment plan, we work with you to find the best solution that fits your financial needs.</p>
                                </div>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>

            <figure className="waves-bottom-center z-index-n1">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                    <path className="text-light-dark" fill="currentColor" fillOpacity="1" d="M0,224L30,229.3C60,235,120,245,180,245.3C240,245,300,235,360,218.7C420,203,480,181,540,170.7C600,160,660,160,720,176C780,192,840,224,900,240C960,256,1020,256,1080,240C1140,224,1200,192,1260,186.7C1320,181,1380,203,1410,213.3L1440,224L1440,320L1410,320C1380,320,1320,320,1260,320C1200,320,1140,320,1080,320C1020,320,960,320,900,320C840,320,780,320,720,320C660,320,600,320,540,320C480,320,420,320,360,320C300,320,240,320,180,320C120,320,60,320,30,320L0,320Z"></path>
                </svg>
            </figure>
        </div>
    );
}
export default Performance;